<template>
  <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar v-if="!vehicle" :title="$t('menu.fleet_defects')" class="mb-1"/>
        <div class="col-sm-12 nopads">
          <single-vehicle-defect-search
              v-if="vehicle"
              :vehicle="vehicle"
              @search="fetchDefects"
          />
          <vehicle-defect-search
              v-else-if="Object.keys(items).length === 0"
              @search="fetchDefects"
          />
          <div class="my-2">
            <div
              class="data-list-item add"
              @click.stop="addDefect"
            >
              <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
              </div>
              <div class="item-text-cont">
                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                <font-awesome-icon
                  icon="wrench"
                  class="card-body-icon"
                />
              </div>
            </div>
      </div>
      <div
        v-if="results.length > 0"
        class="button-container col-sm-12 trip-buttons"
      >
        <button
         :disabled="results.length < 1 || loading"
         class="btn btn-outline-success form-button"
         @click="exportExcel"
        >
            {{ $t('trip.download_excel') }}
        </button>
      </div>
      <vehicle-defect-list :items="results" @edit="editDefect"/>
      <base-modal v-if="editMode" hide-header hide-footer @close="showList">
            <vehicle-defect-editor
                v-if="editMode"
                :defect="defect"
                :is-observer="isObserver"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
      </base-modal>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </div>
</template>

<script>
import VehicleDefectEditor from './VehicleDefectEditor'
import VehicleDefectList from './VehicleDefectList'
import VehicleDefectSearch from './VehicleDefectSearch'
import {restApi} from '../../mixins/RestApiMixin'
import {vehicleHelper} from '../../mixins/VehicleMixin'
import {downloadHelper} from '../../mixins/DownloadMixin.js'
import SingleVehicleDefectSearch from "@/components/vehicle/defect/SingleVehicleDefectSearch";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'VehicleDefects',
    components: {
        BaseModal,
        Navbar, SingleVehicleDefectSearch, VehicleDefectList, VehicleDefectEditor, VehicleDefectSearch},
    mixins: [restApi, vehicleHelper, downloadHelper],
    props: {
        isObserver: {
            type: Boolean,
            default: null
        },
        vehicle: {
            type: Object,
            default: null
        },
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            results: [],
            defect: null,
            editMode: false,
            loading: false,
            vehicles: [],
            lastSearchedParams: null
        }
    },
    watch: {
        items() {
            this.results = this.items
        },
    },
    methods: {
        fetchDefects: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            let url = null
            if (this.lastSearchedParams && this.lastSearchedParams.status !== 0) {
                url = this.vehicleDefectUrl
            } else {
                url = this.vehicleDefectOpenUrl
            }
            this.restFetchParams(url, this.lastSearchedParams, this.handleResponse)
        },

        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
            this.$emit('search-results', response.data)
        },

        editDefect: function (defect) {
            this.defect = defect
            this.editMode = true
        },

        addDefect: function () {
            this.defect = this.newDefect()
            this.editMode = true
        },

        exportExcel: function () {
            this.loading = true
            let params = this.getCommonReportParams(JSON.parse(JSON.stringify(this.lastSearchedParams)))
            this.restGetDownloadFile(this.vehicleDefectReportExcelUrl, params, this.excelDownloadSuccess, this.fileDownloadFail)
        },
        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('vehicle.vehicle_defect_report_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },

        showList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.showList()
            this.fetchDefects(this.lastSearchedParams)
        }
    }
}
</script>

<style scoped>

</style>
